// import Router from '../../router';
const TransTls = {
    getInfo(subRow){
        var t = 'a_sub';
        if('section_model' in subRow) t = 'l_sub';
        let info = '';
        info += "Feeder ID: " + subRow.feeder_id;
        info += "Name: " + subRow.sub_name;
        info += '<br><a target="_blank" href="#/simple-edit/'+t+'/_id/'+subRow._id+'" >اطلاعات</a>';

        
        // var feederNewId = Router.currentRoute._rawValue.params.feederId;

        // info += '<br><a href="' + UrlTls.getBaseUrl() + '/poles/add-feeder/' + poleRow._id +'/'+feederNewId+ '">افزودن فیدر</a>';
        // info += '<a href="' + UrlTls.getBaseUrl() + '/poles/remove-feeder/' + poleRow._id +'/'+feederNewId +'">حذف فیدر</a>';
        return info;
      
    }
}


export {TransTls}